var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between align-middle text-wrap"},[_c('span',{staticClass:"align-middle mt-2",class:_vm.dateClass},[_c('font-awesome-icon',{attrs:{"icon":['far', 'calendar-clock']}}),_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.task.dueDate)))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }